import ChromeBanner from "components/domain/chrome-extension/ChromeBanner";
import { useAuth } from "hooks/useAuth";

import { TilerailBanner } from "./TilerailBanner";

export function DesktopMainBanner() {
    // const { me } = useAuth();

    return (
        <div className="mb-16 hidden px-[var(--page-padding)] md:block">
            <ChromeBanner />
        </div>
    );
}

export function NonDesktopMainBanner() {
    return (
        <div className="mb-6 block px-[var(--page-padding)] md:hidden">
            <TilerailBanner />
        </div>
    );
}

export function MainBanner() {
    return (
        <>
            <DesktopMainBanner />
            <NonDesktopMainBanner />
        </>
    );
}
